import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

interface HeaderSignature {
  Element: HTMLElement;
}

const Header: TemplateOnlyComponent<HeaderSignature> = <template>
  <div class="navbar navbar-expand bg-white shadow-sm py-2" ...attributes>
    <div class="container-fluid container-xl">
      <LinkTo class="navbar-brand fw-bold" @route="index">Xceed</LinkTo>
    </div>
  </div>
</template>;

export default Header;
